










import Vue from 'vue'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import {DEBUG} from '@/env-vars'
import Footer from '../components/all/Footer.vue'

export default Vue.extend({
    components: {
        footerLogin: Footer
    },
    data: () => ({
        splashScreenVisible: true,
        username: '',
        password: ''
    }),
    computed: {
        loginSuccessful: {
            get(): any {
                return this.$store.state.auth.loginSuccessful
            },
            set(value: any) {
                this.SET_LOGIN_SUCCESSFUL(value)
            }
        },
        ...mapGetters('auth', ['isAuthenticated'])
        /* statoPulsanteEntra(): object {
            return {disabled: this.username.length < 3 || this.password.length < 3}
        } */
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapMutations('auth', ['SET_LOGIN_SUCCESSFUL']),
        login() {
            this.$store.dispatch('auth/login', {
                username: this.username,
                password: this.password
            })
        }
    },
    watch: {
        loginSuccessful(newValue) {
            if (newValue) {
                setTimeout(() => {
                    this.$router.push({name: 'IndexServizi'})
                }, 1000)
            }
        }
    },
    created() {
        //
        this.loginSuccessful = false
        // mostriamo lo splash screen
        this.showModal('splash-screen-main')
        // nascondiamo lo splash screen dopo x mills
        const splashScreenTimeout = DEBUG ? 1000 : 2000
        setTimeout(() => {
            // no splash
            this.showModal(null)
            this.splashScreenVisible = false
            // if already logged in we go on
            // if (this.isAuthenticated) this.$router.push({name: 'IndexServizi'})
        }, splashScreenTimeout)
    }
})
